import { useData } from "data/data-provider";
import { policyContacts, resolvePolicyText } from "utils/policyTokens";

/**
 * Policy text for this site (1NOW-11114): the placeholders filled in, with the
 * footer's contact rows and address already wired in for a company record that
 * has none. One hook, so the policy pages and the three checkout modals cannot
 * drift apart; `contacts` is what {{phone}}, {{email}} and {{address}} stand for.
 */
export const usePolicyText = () => {
  const { ourCompany, companyDetails, contactItems, address } = useData();
  const footer = { contactItems, addressItems: address };
  return {
    text: (html?: string | null, opts?: { links?: boolean }) =>
      resolvePolicyText(html, ourCompany, companyDetails, footer, opts),
    contacts: policyContacts(ourCompany, companyDetails, footer),
  };
};
